export default __webpack_public_path__ + "static/media/02.7df14e12.jpg";